export default __webpack_public_path__ + "static/icon-34-4-27e4d5f21bb50470e0d54fcc64b9bfcf.png";